import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

interface IProps {
  breadcrumbLinks: {
    title: string;
    hrefLink: string;
    onclick?: () => void;
  }[];
  alignContent?: string;
  isArrowSeparator?: boolean;
  activeLinkColor?: string;
}

const Breadcrumb = ({
  breadcrumbLinks,
  alignContent,
  isArrowSeparator,
  activeLinkColor
}: IProps) => {
  const router = useRouter();

  const route = router.route;
  //Always show most recent 2 links on breadcrumbs
  const displayedBreadcrumbs =
    breadcrumbLinks?.length > 2 && router.route === '/accounts'
      ? breadcrumbLinks?.slice(-2)
      : breadcrumbLinks;

  const isAccountsPage = router.route === '/accounts';

  return (
    <div
      className={`flex items-center space-x-2 text-lg font-light ${
        route === '/accounts' || alignContent
          ? { alignContent }
          : 'sm:justify-center'
      } overflow-auto whitespace-nowrap xxsm:w-[290px] xsm:w-[340px] msm:w-[390px] mmsm:w-[440px] sm:w-full no-scrollbar`}
    >
      {displayedBreadcrumbs?.map((breadcrumb, index) => (
        <>
          <Link
            href={breadcrumb.hrefLink}
            onClick={breadcrumb.onclick}
            key={index}
          >
            <p
              className={`${
                breadcrumbLinks?.length === 1 ||
                (breadcrumbLinks?.length !== 1 && index !== 0)
                  ? `text-${activeLinkColor} ${
                      isAccountsPage
                        ? `font-semibold sm:text-base hover:font-semibold hover:text-primary`
                        : `font-normal sm:text-sm hover:font-normal hover:text-darkBlue`
                    }`
                  : route !== '/accounts'
                  ? 'hover:text-darkBlue sm:text-sm sm:font-normal'
                  : 'text-black13 hover:text-primary hover:font-semibold font-semibold sm:text-base'
              } inline-block ${
                breadcrumbLinks.length - 1 === index && !isAccountsPage
                  ? 'font-bold text-darkBlue' // Highlight last breadcrumb item if not on accounts page
                  : breadcrumbLinks.length - 1 === index
                  ? 'sm:w-full  text-[#ff4545]'
                  : ''
              } text-sm font-bold leading-[30px] hover:font-medium cursor-pointer`}
            >
              {breadcrumb.title}
            </p>
          </Link>
          {breadcrumbLinks?.length - 1 !== index &&
            (isArrowSeparator ? (
              <Image
                src={'/black-right-arrow.svg'}
                alt="right arrow"
                width={16}
                height={16}
              />
            ) : (
              <span className="sm:px-1 xl:px-3">/</span>
            ))}
        </>
      ))}
    </div>
  );
};

export default Breadcrumb;
